<template>
    <div class="page-main">
        <div>
            <section
                class="title-section">
                <div class="title-container">
                    <h1 class="elementor-heading-title elementor-size-default">POLÍTICA DE COOKIES</h1>
                </div>
            </section>
            <section class="info-section">
                <h4 class="title">
                    ¿Qué son las cookies?
                </h4>
                <div class="text">
                    Las cookies y/o o tecnologías similares son ficheros que almacenan y recuperan información mientras navegas. En general, estas tecnologías pueden servir para finalidades muy diversas, como, por ejemplo, reconocerte como usuario, obtener información sobre tus hábitos de navegación, o personalizar la forma en que se muestra el contenido. Los usos concretos que hacemos de estas tecnologías se describen en el cuadro que figura al final del apartado siguiente.
                </div>
            </section>
            <section class="info-section">
                <h4 class="title">
                    ¿Qué cookies utilizamos?
                </h4>
                <div class="text">
                    Según la entidad, la finalidad o el plazo para la que se traten los datos obtenidos a través de las cookies, este sitio web podrá usar:
                </div>
                <div class="text">
                    a) Según la entidad que las gestione:
                </div>
                <ul class="text">
                    <li>Cookies propias: Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio gestionado por el propio editor y desde el que se presta el servicio solicitado por el usuario.</li>
                    <li>Cookies de terceros: Son aquellas que se envían al equipo terminal del usuario desde un equipo o dominio que no es gestionado por el editor, sino por otra entidad que trata los datos obtenidos a través de las cookies.</li>
                </ul>
                <div class="text">
                    b) Según su finalidad:
                </div>
                <ul class="text">
                    <li>Cookies necesarias: Son aquellas que permiten al usuario navegar a través del sitio web y utilizar las diferentes opciones o servicios que en ella existen como podría ser controlar el tráfico y comunicación de datos, realizar el proceso de compra de un pedido o utilizar elementos de seguridad durante la navegación.</li>
                    <li>Cookies de preferencias: Son aquellas que permiten recordar información para que el usuario acceda al servicio con determinadas características que pueden diferenciar su experiencia de la de otros usuarios, como por ejemplo, las configuraciones del usuario respecto al idioma, el número de resultados a mostrar cuando el usuario realiza una búsqueda, el aspecto o contenido del servicio en función del tipo de navegador a través del cual el usuario accede al mismo o la configuración regional desde donde se accede al servicio.</li>
                    <li>Cookies de estadística: Son aquellas que permiten realizar el seguimiento y análisis del comportamiento de los usuarios en los sitios web. La información recogida mediante este tipo de cookies se utiliza para la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de perfiles de navegación de los usuarios de dichos sitios, con el fin de introducir mejoras en el servicio en función de los datos de uso.</li>
                    <li>Cookies marketing: Son aquellas que permiten la gestión eficaz de los espacios publicitarios que se han incluido en el sitio web desde la que se presta el servicio. Permiten adecuar el contenido de la publicidad para que ésta sea relevante para el usuario y para evitar mostrar anuncios que el usuario ya haya visto.</li>
                    <li>Cookies de publicidad comportamental: Son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, el editor haya incluido en un sitio web, aplicación o plataforma desde la que presta el servicio solicitado. Estas cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función de éste.</li>
                    <li>Cookies de redes sociales externas: Son aquellas que se utilizan para que los usuarios puedan interactuar con el contenido de diferentes plataformas sociales (por ejemplo, Facebook), y se utilizan por estos terceros para realizar publicidad comportamental, el análisis y seguimiento y la investigación de los mercados por parte del tercero titular de la red social, así como para finalidades que aparecen en sus condiciones legales.</li>
                </ul>
            </section>
            <section class="info-section">
                <h4 class="title">
                    Tipo de cookies que utiliza esta web y cómo administrarlas
                </h4>
                <div class="text">
                    Las cookies que utiliza la suite de Dinapsis aparecen en la Declaración de cookies a continuación. Tenga en cuenta que:
                </div>
                <div class="text">
                    En cualquier momento puede cambiar o retirar su consentimiento desde la Declaración de cookies en nuestro sitio web.
                </div>
                <div class="text">
                    Obtenga más información sobre quiénes somos, cómo puede contactarnos y cómo procesamos los datos personales en nuestra Política de privacidad.
                </div>
                <div class="text">
                    Al contactarnos respecto a su consentimiento, por favor, indique el ID y la fecha de su consentimiento.
                </div>
                <div class="text">
                    Su consentimiento se aplica a los siguientes dominios: www.suite.dinapsis.es
                </div>
                <div class="table-group">
                    <div class="title">
                        Necesario
                    </div>
                    <div class="text">
                        Las cookies necesarias ayudan a hacer una página web utilizable activando funciones básicas como la navegación en la página y el acceso a áreas seguras de la página web. La página web no puede funcionar adecuadamente sin estas cookies.
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Proveedor</th>
                                <th>Propósito</th>
                                <th>Duración máxima de almacenamiento</th>
                                <th>Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>AUTH_SESSION_ID</td>
                                <td>Dinapsis</td>
                                <td>Esta cookie sirve para identificar al usuario en la aplicación</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                            <tr>
                                <td>AUTH_SESSION_ID_LEGACY</td>
                                <td>Dinapsis</td>
                                <td>Esta cookie sirve para identificar al usuario en la aplicación</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                            <tr>
                                <td>KEYCLOAK_IDENTITY</td>
                                <td>Dinapsis</td>
                                <td>Esta cookie sirve para identificar al usuario en la sesión del navegador para todas las aplicaciones de suite.</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                            <tr>
                                <td>KEYCLOAK_IDENTITY_LEGACY</td>
                                <td>Dinapsis</td>
                                <td>Esta cookie sirve para identificar al usuario en la sesión del navegador para todas las aplicaciones de suite.</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                            <tr>
                                <td>KEYCLOAK_SESSION</td>
                                <td>Dinapsis</td>
                                <td>Esta cookie sirve para identificar la sesión del usuario para todas las aplicaciones de suite.</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                            <tr>
                                <td>KEYCLOAK_SESSION_LEGACY</td>
                                <td>Dinapsis</td>
                                <td>Esta cookie sirve para identificar la sesión del usuario para todas las aplicaciones de suite.</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="table-group">
                    <div class="title">
                        Estadística
                    </div>
                    <div class="text">
                        Las cookies estadísticas ayudan a los propietarios de páginas web a comprender cómo interactúan los visitantes con las páginas web reuniendo y proporcionando información de forma anónima.
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Proveedor</th>
                                <th>Propósito</th>
                                <th>Duración máxima de almacenamiento</th>
                                <th>Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>pk_id</td>
                                <td>Piwik Pro</td>
                                <td>Esta cookie sirve para identificar al usuario en el servicio de piwik y así poder recoger datos estadísticos sobre el uso de la web.</td>
                                <td>Indefinido</td>
                                <td>Cookie HTTP</td>
                            </tr>
                            <tr>
                                <td>pk_ses</td>
                                <td>Piwik Pro</td>
                                <td>Esta cookie sirve para identificar la sesión del usuario en el servicio de piwik y así poder recoger datos estadísticos sobre el uso de la web.</td>
                                <td>Sesión</td>
                                <td>Cookie HTTP</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
            <section class="info-section">
                <h4 class="title">
                    ¿Cómo administrar las cookies?
                </h4>
                <div class="text">
                    El usuario tiene la opción de permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su terminal. Para obtener más información, consulte las instrucciones y manuales de su navegador para ampliar esta información:
                </div>
                <div class="text">
                    <p>Google Chrome: pulse<span style="color: #8096b0;">&nbsp;<a style="color: #8096b0;" href="https://support.google.com/?hl=es">aquí</a></span>.<br>Mozilla Firefox: pulse&nbsp;<span style="color: #8096b0;"><a style="color: #8096b0;" href="https://support.mozilla.org/es/">aquí</a></span>.<br>Internet Explorer: pulse<span style="color: #8096b0;">&nbsp;<a style="color: #8096b0;" href="https://support.microsoft.com/es-es">aquí</a></span>.<br>Safari: pulse&nbsp;<span style="color: #8096b0;"><a style="color: #8096b0;" href="https://support.apple.com/es-es">aquí</a>.</span></p>
                </div>
                <div class="text">
                    No obstante, la inhabilitación de las cookies podría modificar el funcionamiento del sitio web. En caso de bloquear el uso de cookies en su navegador es posible que algunos servicios o funcionalidades del sitio web no estén disponibles.
                </div>
            </section>
            <section class="info-section">
                <h4 class="title">
                    Actualización de la política de cookies
                </h4>
                <div class="text">
                    En el caso de que las características o fines de uso de las cookies de esta página web sean modificadas, se le informará acerca de esos cambios con el fin de recabar nuevamente su consentimiento en aquellos casos en que fuese necesario.
                </div>
            </section>
            <section class="info-section">
                <h4 class="title">
                    Información Adicional sobre el tratamiento de datos es esta página web
                </h4>
                <div class="text">
                    Dispone de más información sobre los tratamientos de sus datos personales que se realizan a través de la página web dinapsis.com por parte de AGBAR, S.L.U. (en adelante, “AGBAR”) con NIF B-63152664 y domicilio social calle Santa Leonor 39, (28037) Madrid en nuestra política de privacidad.
                </div>
                <div class="text">
                    Si tiene cualquier duda sobre el tratamiento de su información personal, puede contactar con el Delegado de Protección de Datos de AGBAR mediante los siguientes puntos de contacto:
                </div>
                <ul class="text">
                    <li>Correo electrónico: <a style="color: #8096b0;" href="mailto:dpo.es@agbar.es" target="_blank" rel="noopener">dpo.es@agbar.es</a></li>
                    <li>Correo postal: Passeig de la Zona Franca 48, Planta 6, (08038) Barcelona, a la atención del Delegado de Protección de Datos de AGBAR.</li>
                </ul>
            </section>
        </div>
    </div>
</template>
<script>

export default {
  name: 'CookiesPolicyPage',
  components: {
  }
};
</script>
<style lang="scss" scoped>
.page-main {
    margin: 0 -79px -20px;
}
.title-section {
    background-color: rgb(0, 47, 108);
    color:white;
    height: 400px;
    & .title-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        & h1 {
            @include tallFont;
            font-size: 60px;
            font-weight: 500;
            line-height: 72px;
            margin: 0px;
            height: 120px;
        }
    }

}
.info-section {
    margin-left: 27%;
    margin-right: 27%;
    font-family: 'TheSansVeolia', 'TheSans-W5Pla';
    margin-top: 50px;
    h4.title {
        font-weight: bold;
        color: rgb(58, 58, 58);
        margin-bottom: 20px;
        margin-top: 0px;
    }
    .text {
        color: rgb(122,122,122);
        margin-bottom: 24px;
        text-align: justify;
        line-height: 27px;
    }
    a {
        color: rgb(103, 210, 223);
    }
    .table-group {
        border: 1px solid rgb(51, 51, 51);
        margin: 3px;
        .title,
        thead th {
            color: rgb(122,122,122);
            margin-bottom: 24px;
            text-align: justify;
            line-height: 27px;
        }
        thead th {
            font-weight: bold;
        }
        tbody td {
            color: rgb(122,122,122);
            margin-bottom: 24px;
            text-align: justify;
            line-height: 27px;
            max-width: 300px;
            border-bottom: 1px solid rgb(51, 51, 51);
            border-right: 1px solid rgba(0, 0, 0, 0.1);
            border-left: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
